module.exports = __webpack_public_path__ + "e034e53b7d397bc891e2849c09606860.svg";